import {
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
  Tooltip,
} from '@mui/material';
import Iconify from '@/components/Iconify';
import useResponsive from '@/hooks/useResponsive';
import { InAppPopupFilters } from '../types';
import { IN_APP_POPUP_PLATFORM_OPTIONS } from '../utils';

type InAppPopupsTableToolbarProps = {
  filters: InAppPopupFilters;
  onFilters: (name: keyof InAppPopupFilters, value: string) => void;
  onResetFilters: VoidFunction;
  isFiltered: boolean;
};

export default function InAppPopupsTableToolbar({
  filters,
  onFilters,
  onResetFilters,
  isFiltered,
}: InAppPopupsTableToolbarProps) {
  const downMd = useResponsive('down', 'md');

  return (
    <Grid
      container
      spacing={2}
      direction={{ xs: 'column', md: 'row' }}
      sx={{ py: 2.5, px: 3 }}
    >
      <Grid item xs={12} md={3}>
        <TextField
          fullWidth
          select
          size="small"
          label="Platform"
          value={filters.platform}
          onChange={(event) => onFilters('platform', event.target.value)}
        >
          <MenuItem value="">All</MenuItem>
          {IN_APP_POPUP_PLATFORM_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} md={isFiltered ? 8 : 9}>
        <TextField
          fullWidth
          value={filters.query}
          onChange={(event) => onFilters('query', event.target.value)}
          placeholder="Search in popups..."
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Iconify
                  icon={'eva:search-fill'}
                  sx={{ color: 'text.disabled', width: 20, height: 20 }}
                />
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      {isFiltered && (
        <Grid item xs={12} md={1}>
          <Tooltip title="Reset filters" placement="top">
            <span>
              <IconButton
                color="inherit"
                onClick={onResetFilters}
                sx={{
                  fontSize: 14,
                  display: 'flex',
                  gap: 0.5,
                  width: downMd ? '100%' : 'auto',
                  justifyContent: downMd ? 'flex-start' : 'center',
                }}
              >
                <Iconify
                  icon="eva:close-circle-outline"
                  sx={{ width: 20, height: 20 }}
                />
                {downMd && 'Reset filters'}
              </IconButton>
            </span>
          </Tooltip>
        </Grid>
      )}
    </Grid>
  );
}
